import { useState } from "react";

const SortData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config || {key: null, direction: 'none'})

    const sortedItems = (() => {

        let sortableItems = Array.isArray(items) ? [...items] : [];

        if (sortConfig.key !== null && sortConfig.direction !== 'none') {
            sortableItems.sort((a, b) => {
                const aVal = a[sortConfig.key];
                const bVal = b[sortConfig.key];
                const direction = sortConfig.direction === 'ascending' ? 1 : -1;

                const aEmpty = aVal === null || aVal === undefined || aVal === '';
                const bEmpty = bVal === null || bVal === undefined || bVal === '';
                if (aEmpty || bEmpty) {
                    if (aEmpty && bEmpty) return 0;
                    return aEmpty ? 1 : -1;   //Empty values always sort last, regardless of direction
                }

                if (typeof aVal === 'string' && typeof bVal === 'string') {
                    return aVal.localeCompare(bVal, 'es', {sensitivity: 'base'}) * direction;
                }

                if (aVal < bVal) return -direction;
                if (aVal > bVal) return direction;
                return 0;
            });
        }
        return sortableItems;
    })();

    const requestSort = (key) => {
        let direction = 'ascending';

        if (sortConfig.key === key) {
            if (sortConfig.direction === 'ascending') {
                direction = 'descending';
            } else if (sortConfig.direction === 'descending') {
                direction = 'none';
            } else {
                direction = 'ascending';
            }
        }
        setSortConfig({key, direction});
    }

    const getIcon = (key) => {
        if (sortConfig.key === key && sortConfig.direction !== 'none') {
            return sortConfig.direction === 'ascending' ? '▲' : '▼';
        }
        return '';        
    }

    return {sortedItems, sortConfig, requestSort, getIcon};
}

export default SortData;